export interface MangaChapter {
  id: string;
  mangaId: string;
  chapterNumber: number;
  title: string;
  updatedAt: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  genres: string[];
  rating: number;
  status: '连载中' | '已完结';
  viewCount: number;
  updatedAt: string;
  chapters: MangaChapter[];
}

export const mangaList: Manga[] = [
  {
    id: 'manga-1',
    title: '她的心动瞬间',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20young%20couple%20in%20cherry%20blossom%20scene%2C%20soft%20pastel%20pink%20tones%2C%20watercolor%20illustration%20style%2C%20clean%20simple%20background%20with%20light%20gradient%2C%20elegant%20romantic%20mood%2C%20high%20quality%20digital%20art%2C%20warm%20lighting%2C%20Korean%20webtoon%20aesthetic&width=600&height=800&seq=manga-cover-1&orientation=portrait',
    description: '高冷校草林宇轩转学到圣德高中第一天，就意外撞见了学霸少女苏小晚的秘密。两个看似毫无交集的人，在一次次的误会与巧合中，渐渐走进了彼此的内心。然而，林宇轩隐藏的身份和家族秘密，将成为两人感情路上最大的考验……',
    genres: ['恋爱', '校园'],
    rating: 9.5,
    status: '连载中',
    viewCount: 3250000,
    updatedAt: '2026-07-03',
    chapters: [
      { id: 'ch-1-1', mangaId: 'manga-1', chapterNumber: 88, title: '第88话 无法说出口的心意', updatedAt: '2026-07-03' },
      { id: 'ch-1-2', mangaId: 'manga-1', chapterNumber: 87, title: '第87话 雨中的告白', updatedAt: '2026-06-28' },
      { id: 'ch-1-3', mangaId: 'manga-1', chapterNumber: 86, title: '第86话 意外的相遇', updatedAt: '2026-06-21' },
      { id: 'ch-1-4', mangaId: 'manga-1', chapterNumber: 85, title: '第85话 谎言与真相', updatedAt: '2026-06-14' },
      { id: 'ch-1-5', mangaId: 'manga-1', chapterNumber: 84, title: '第84话 夜晚的约定', updatedAt: '2026-06-07' },
    ],
  },
  {
    id: 'manga-2',
    title: '暗影侦探',
    author: '金贤秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%20art%2C%20detective%20in%20dark%20alley%20with%20neon%20signs%2C%20noir%20atmosphere%2C%20rainy%20night%20scene%2C%20dramatic%20lighting%20with%20shadows%2C%20clean%20simple%20composition%2C%20dark%20moody%20aesthetic%2C%20high%20contrast%2C%20Korean%20webtoon%20style&width=600&height=800&seq=manga-cover-2&orientation=portrait',
    description: '首尔江南区接连发生离奇失踪案件，退役刑警姜道贤被紧急召回。他必须在72小时内揭开真相，否则下一个受害者将是他的女儿。层层迷雾背后，隐藏着一个惊天大阴谋……',
    genres: ['悬疑', '动作'],
    rating: 9.7,
    status: '连载中',
    viewCount: 5180000,
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch-2-1', mangaId: 'manga-2', chapterNumber: 56, title: '第56话 最后的线索', updatedAt: '2026-07-02' },
      { id: 'ch-2-2', mangaId: 'manga-2', chapterNumber: 55, title: '第55话 地下密室的秘密', updatedAt: '2026-06-25' },
      { id: 'ch-2-3', mangaId: 'manga-2', chapterNumber: 54, title: '第54话 背叛者', updatedAt: '2026-06-18' },
      { id: 'ch-2-4', mangaId: 'manga-2', chapterNumber: 53, title: '第53话 绝境求生', updatedAt: '2026-06-11' },
      { id: 'ch-2-5', mangaId: 'manga-2', chapterNumber: 52, title: '第52话 追踪', updatedAt: '2026-06-04' },
    ],
  },
  {
    id: 'manga-3',
    title: '异界征服者',
    author: '李泰浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20action%20manhwa%20cover%20art%2C%20warrior%20with%20sword%20in%20magical%20realm%2C%20epic%20fantasy%20scene%20with%20dragons%2C%20golden%20and%20crimson%20color%20tones%2C%20clean%20simple%20background%2C%20heroic%20pose%2C%20high%20quality%20illustration%2C%20Korean%20webtoon%20aesthetic%2C%20dramatic%20lighting&width=600&height=800&seq=manga-cover-3&orientation=portrait',
    description: '普通大学生金宇镇意外被召唤到剑与魔法的异世界，获得"征服者"系统。在这个弱肉强食的世界里，他必须不断变强，征服一个又一个领地，最终成为异界之王！',
    genres: ['奇幻', '动作'],
    rating: 9.3,
    status: '连载中',
    viewCount: 4120000,
    updatedAt: '2026-07-01',
    chapters: [
      { id: 'ch-3-1', mangaId: 'manga-3', chapterNumber: 120, title: '第120话 最终决战', updatedAt: '2026-07-01' },
      { id: 'ch-3-2', mangaId: 'manga-3', chapterNumber: 119, title: '第119话 王位之争', updatedAt: '2026-06-24' },
      { id: 'ch-3-3', mangaId: 'manga-3', chapterNumber: 118, title: '第118话 远古巨龙', updatedAt: '2026-06-17' },
      { id: 'ch-3-4', mangaId: 'manga-3', chapterNumber: 117, title: '第117话 联盟破裂', updatedAt: '2026-06-10' },
      { id: 'ch-3-5', mangaId: 'manga-3', chapterNumber: 116, title: '第116话 新的力量', updatedAt: '2026-06-03' },
    ],
  },
  {
    id: 'manga-4',
    title: '甜蜜陷阱',
    author: '崔美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20manhwa%20cover%20art%2C%20elegant%20woman%20and%20man%20in%20luxury%20setting%2C%20dramatic%20red%20and%20white%20color%20scheme%2C%20clean%20minimalist%20background%2C%20mature%20romantic%20atmosphere%2C%20high%20fashion%20aesthetic%2C%20Korean%20webtoon%20style%2C%20soft%20dramatic%20lighting&width=600&height=800&seq=manga-cover-4&orientation=portrait',
    description: '为了调查父亲死亡的真相，韩素拉潜入顶级财阀家族。她精心设计每一个接近目标的机会，却在复仇的过程中，不由自主地爱上了仇人的儿子——那个温柔又危险的财阀继承人。',
    genres: ['恋爱', '都市'],
    rating: 9.6,
    status: '连载中',
    viewCount: 2890000,
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch-4-1', mangaId: 'manga-4', chapterNumber: 72, title: '第72话 真相大白', updatedAt: '2026-06-30' },
      { id: 'ch-4-2', mangaId: 'manga-4', chapterNumber: 71, title: '第71话 最后的考验', updatedAt: '2026-06-23' },
      { id: 'ch-4-3', mangaId: 'manga-4', chapterNumber: 70, title: '第70话 信任崩塌', updatedAt: '2026-06-16' },
      { id: 'ch-4-4', mangaId: 'manga-4', chapterNumber: 69, title: '第69话 卧底身份暴露', updatedAt: '2026-06-09' },
      { id: 'ch-4-5', mangaId: 'manga-4', chapterNumber: 68, title: '第68话 危险的赌注', updatedAt: '2026-06-02' },
    ],
  },
  {
    id: 'manga-5',
    title: '搞笑一家人',
    author: '张道允',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20slice%20of%20life%20manhwa%20cover%20art%2C%20funny%20family%20characters%20in%20bright%20colorful%20setting%2C%20warm%20yellow%20and%20orange%20tones%2C%20cartoonish%20illustration%20style%2C%20clean%20simple%20background%2C%20happy%20energetic%20mood%2C%20Korean%20webtoon%20aesthetic&width=600&height=800&seq=manga-cover-5&orientation=portrait',
    description: '五口之家的爆笑日常！严厉的爸爸、唠叨的妈妈、叛逆的姐姐、中二的弟弟，还有一个总被遗忘的"透明人"老三。每天都有新的笑料发生，让你笑到停不下来！',
    genres: ['喜剧', '校园'],
    rating: 9.1,
    status: '已完结',
    viewCount: 7560000,
    updatedAt: '2026-05-15',
    chapters: [
      { id: 'ch-5-1', mangaId: 'manga-5', chapterNumber: 200, title: '第200话 最终回：永不结束的日常', updatedAt: '2026-05-15' },
      { id: 'ch-5-2', mangaId: 'manga-5', chapterNumber: 199, title: '第199话 毕业典礼', updatedAt: '2026-05-08' },
      { id: 'ch-5-3', mangaId: 'manga-5', chapterNumber: 198, title: '第198话 最后的考试', updatedAt: '2026-05-01' },
      { id: 'ch-5-4', mangaId: 'manga-5', chapterNumber: 197, title: '第197话 妈妈的反击', updatedAt: '2026-04-24' },
      { id: 'ch-5-5', mangaId: 'manga-5', chapterNumber: 196, title: '第196话 爸爸的秘密', updatedAt: '2026-04-17' },
    ],
  },
  {
    id: 'manga-6',
    title: '灵异学院',
    author: '韩尚宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20supernatural%20manhwa%20cover%20art%2C%20haunted%20school%20building%20at%20night%2C%20ghostly%20figure%20in%20corridor%2C%20dark%20purple%20and%20black%20color%20scheme%2C%20eerie%20atmosphere%2C%20clean%20simple%20composition%2C%20spooky%20Korean%20webtoon%20style%2C%20moonlight%20through%20windows&width=600&height=800&seq=manga-cover-6&orientation=portrait',
    description: '转学生金敏俊被分配到了传说中的"诅咒教室"——4楼404室。传闻每届使用这个教室的学生都会遭遇不测。当敏俊亲眼目睹第一个同学的"意外"之后，他意识到，这个诅咒是真实存在的……',
    genres: ['恐怖', '悬疑'],
    rating: 9.4,
    status: '连载中',
    viewCount: 1980000,
    updatedAt: '2026-06-29',
    chapters: [
      { id: 'ch-6-1', mangaId: 'manga-6', chapterNumber: 42, title: '第42话 消失的404室', updatedAt: '2026-06-29' },
      { id: 'ch-6-2', mangaId: 'manga-6', chapterNumber: 41, title: '第41话 镜中的脸', updatedAt: '2026-06-22' },
      { id: 'ch-6-3', mangaId: 'manga-6', chapterNumber: 40, title: '第40话 午夜铃声', updatedAt: '2026-06-15' },
      { id: 'ch-6-4', mangaId: 'manga-6', chapterNumber: 39, title: '第39话 第三个牺牲者', updatedAt: '2026-06-08' },
      { id: 'ch-6-5', mangaId: 'manga-6', chapterNumber: 38, title: '第38话 走廊尽头', updatedAt: '2026-06-01' },
    ],
  },
];

export const featuredManga = mangaList.slice(0, 3);

export const latestUpdates = [...mangaList].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

export const getMangaById = (id: string): Manga | undefined => mangaList.find((m) => m.id === id);

export const getMangaByGenre = (genre: string): Manga[] => mangaList.filter((m) => m.genres.includes(genre));